export const pageAnimation = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        transition: {
            duration: .5,
            when: "beforeChildren",
            staggerChildren: 0.25
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.5,
        }
    }
}

export const stagger = {
    inital: {
        opacity: 0
    },
    animate: {
        opacity: 1,
        transition:{
            staggerChildren: .25,
            when: 'beforeChildren'
        }
    }
}

export const cardVariant = {
    initial:{
        opacity: 0, 
        scale: 0,
    },
    animate:{
        opacity: 1, 
        scale: 1
    }
}

export const modalVariant = {
    initial:{
        opacity: 0
    },
    animate:{
        opacity: 1,
        transition:{
            staggerChildren: 0.2, 
            delayChildren: 0.2
        }
    }
}

export const imgVariant = {
    initial:{
        opacity: 0,
        y: "-20%"
    },
    animate: {
        opacity: 1,
        y: 0,
        transition:{
            duration: .35
        }
    },
    exit:{
        opacity: 0,
        y: "-20%"
    }
}

export const lineAnim = {
    initial: {
        width: 0
    },
    animate: {
        width: '90%',
        transition: {duration: .5}
    }
}

export const textVariantLeft = {
    initial: {
        x: "-100%",
        opacity: 0
    },
    animate: {
        opacity: 1,
        x: 0,
        transition:{
            type: "spring",
            stiffness: 300, 
            damping: 20,
        }
    }
}

export const textVariantRight = {
    initial: {
        x: "100%",
        opacity: 0,
        visability: "hidden"
    },
    animate: {
        opacity: 1,
        x: 0,
        visability: "show",
        transition:{
            type: "spring",
            stiffness: 300, 
            damping: 20,
            duration: .5
        }
    }
}

export const imageSliderVariant = {
    initial: (direction) => {
        return {
            x: direction > 0 ? "100%" : direction === 0 ? "0" : "-100%",
            y: direction === 0 ? "-20%" : "0",
            opacity: 0
        }
    },
    animate: {
        x: 0,
        y: 0,
        opacity: 1,
        transition:{
            type: "spring", 
            stiffness: 200, 
            damping: 20
        }
    },
    exit: (direction) => {
        return {
            x: direction < 0  ? "100%" : "-100%",
            opacity: 0
        }
    }
}

export const gearAnimation = {
    initial:{
        rotate: '0deg',
        color: 'var(--color-DD)',
        transition:{
            duration: .75,
            ease: 'linear'
        }
    },
    animate:{
        rotate: '180deg',
        color: 'var(--color-B)',
        transition:{
            duration: .75,
            ease: 'linear'
        }
    }
}

export const toggleAnimation = {
    initial:{
        x: "-100%",
        zIndex: -1,
        transition:{
            duration: .75,
        }
    },
    animate:{
        x: 0,
        zIndex: 1,
        transition:{
            duration: .75,
        }
    }
}